import { Home, Plus, Users, Settings, Clock } from 'lucide-react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useI18n } from '../contexts/I18nContext';

const BottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useI18n();

  const navItems = [
    { id: 'home', icon: Home, label: t('nav.home'), path: '/home', testId: 'nav-home-tab' },
    { id: 'recent', icon: Clock, label: t('nav.recent'), path: '/recent', testId: 'nav-recent-tab' },
    { id: 'groups', icon: Users, label: t('nav.groups'), path: '/groups', testId: 'nav-groups-tab' },
    { id: 'settings', icon: Settings, label: t('nav.settings'), path: '/settings', testId: 'nav-settings-tab' }
  ];

  const isActive = (path) => location.pathname === path;

  const handleAddClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    navigate('/add');
  };

  return (
    <nav className="fixed bottom-0 left-0 right-0 w-full max-w-md mx-auto bg-white/80 backdrop-blur-xl border-t border-slate-100" style={{ zIndex: 9999 }}>
      <div className="flex justify-around items-center h-20 px-2">
        {navItems.slice(0, 2).map((item) => {
          const Icon = item.icon;
          return (
            <button
              key={item.id}
              data-testid={item.testId}
              onClick={() => navigate(item.path)}
              className={`${
                isActive(item.path)
                  ? 'text-slate-900 font-bold'
                  : 'text-slate-400 font-medium'
              } flex flex-col items-center gap-1 transition-colors`}
            >
              <Icon size={24} />
              <span className="text-xs">{item.label}</span>
            </button>
          );
        })}

        <button
          data-testid="nav-add-tab"
          onClick={handleAddClick}
          type="button"
          className="w-14 h-14 bg-slate-900 text-white rounded-full flex items-center justify-center -translate-y-4 shadow-lg active:scale-95 transition-transform relative z-10"
        >
          <Plus size={28} />
        </button>

        {navItems.slice(2).map((item) => {
          const Icon = item.icon;
          return (
            <button
              key={item.id}
              data-testid={item.testId}
              onClick={() => navigate(item.path)}
              className={`${
                isActive(item.path)
                  ? 'text-slate-900 font-bold'
                  : 'text-slate-400 font-medium'
              } flex flex-col items-center gap-1 transition-colors`}
            >
              <Icon size={24} />
              <span className="text-xs">{item.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default BottomNav;
